<template>
  <aha-modal
    :title="reminderPromotionOnCancellationTitle"
    ref="promotion-on-cancel-reminder-popup"
    id="promotion-on-cancel-reminder-popup"
    @hide="handleClosePromotionOnCancelReminderPopup()"
    action-position="justify-center"
    action-alignment="flex-col items-center"
    width="451px"
  >
    <img
      class="mb-6"
      :src="require('@/assets/images/cancellation-offer/3-remind.jpg')"
    />
    <p
      v-html="$i18nPresenter.t('exclusiveOfferPercentage', {
        offer: offerPercentage
      })"
    >
    </p>
    <template #action>
      <aha-button
        class="w-full mb-3"
        @click="handleClosePromotionOnCancelReminderPopup()"
      >
        {{ $i18nPresenter.t('I will stay') }}
      </aha-button>
      <aha-link
        @click="handleContinueWithCancellation()"
      >
        {{ $i18nPresenter.t('I will cancel and lose the offer') }}
      </aha-link>
    </template>
  </aha-modal>
</template>
<script >
import { mapState } from 'vuex'

export default {
  name: 'PromotionOnCancelReminderModal',
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    reminderPromotionOnCancellationTitle() {
      const { firstName, lastName } = this.currentUser
      return this.$i18nPresenter.t('heyXYouStillGotYOff', {
        firstName,
        lastName,
        percent: this.offerPercentage,
      })
    },
    offerPercentage() {
      if (!this.currentUser.id) return null
      if (this.currentUser.id % 2 === 0) return '25%'
      return '50%'
    },
  },
  methods: {
    handleClosePromotionOnCancelReminderPopup() {
      this.$emit('handleClosePromotionOnCancelReminderPopup')
    },
    handleContinueWithCancellation() {
      this.$emit('handleContinueWithCancellation')
    },

  },
}
</script>
